import useTable from "../../../../../MainComponents/Hooks/useTable";

function SetsTable({ id, tableFor = "sets" }) {
  const table = useTable(tableFor, "", "", "", "", id);

  return <div className="h-fit w-full">{table}</div>;
}

export default SetsTable;
